/**
 * src/api/scraping.js
 * Funciones para trigger del pipeline y consulta de estado/logs.
 */
import api from './client'

export const getEstado = (clienteId) =>
  api.get(`/scraping/${clienteId}/estado`).then(r => r.data)

export const getLogs = (clienteId, limit = 20) =>
  api.get(`/scraping/${clienteId}/logs`, { params: { limit } }).then(r => r.data)

export const triggerPipeline = (clienteId, tipo = 'ambos', dryRun = false) =>
  api.post(`/scraping/${clienteId}/trigger`, null, {
    params: { tipo, dry_run: dryRun },
  }).then(r => r.data)

export const getSchedulerJobs = () =>
  api.get('/scraping/scheduler/jobs').then(r => r.data)

// Diagnóstico del embudo OCs → catálogo (admin, read-only).
export const getDiagnosticoCatalogo = (clienteId) =>
  api.get(`/scraping/${clienteId}/diagnostico-catalogo`).then(r => r.data)
